module.exports = __webpack_public_path__ + "static/media/Ginny Li.c2493425.png";